// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"Q8-z"};